import { createResourceRequests } from '../../helpers/resource';
import * as normalizers from './normalizers';

const register = (props) => ({
  method: 'POST',
  url: '/api/user',
  data: normalizers.toRegister(props),
  normalizer: normalizers.fromRegister,
});

const endpoints = {
  register,
};

const api = createResourceRequests(endpoints);

export default api;



// WEBPACK FOOTER //
// ./src/resources/app/api.js